// extracted by mini-css-extract-plugin
export default {"page_404":"Error_page_404__ZaMxe","four_zero_four_bg":"Error_four_zero_four_bg__Kil-9","link_404":"Error_link_404__B33VP","contant_box_404":"Error_contant_box_404__Ljt-1"};